<template>
  <!-- 顶部导航 -->
  <van-nav-bar
    title="项目信息"
    left-arrow
    @click-left="onClickBack"
    fixed
    safe-area-inset-top
  >
    ></van-nav-bar
  >
  <div class="ProjectInformation" style="padding-top: 46px">
    <van-search
      v-model="search"
      background="#f3f3f3"
      show-action
      placeholder="请输入项目单号(A10单号)或名称搜索"
      @search="onSearch"
    >
      <template #action>
        <div @click="showPicker = true" style="color: rgb(150, 151, 153)">
          筛选
        </div>
      </template>
    </van-search>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        v-model:error="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div v-show="total > 0">
          <span
            style="
              margin-top: 10px;
              margin-bottom: 10px;
              text-align: center;
              display: block;
              color: rgb(150, 151, 153);
              font-size: 14px;
            "
            >项目合计:{{ total }}</span
          >
        </div>
        <van-cell v-for="item in list" :key="item" @click="jump(item)">
          <div>
            <span style="color: #e57e05"
              >【{{ returnType(item.relationFlag) }}】{{
                item.projectCode
              }}</span
            >
            <br />
            <div>
              <!-- <span>A10单号:{{ item.biNo }}</span> -->
              <span v-if="item.biNo != null">A10单号:{{ item.biNo }}</span>
              <span v-if="item.biNo == null">A10单号:暂无</span>
            </div>
            <span>项目名称:{{ item.projectName }}</span>
            <!-- <br />
            <span>{{ item.departmentName }} {{ item.projectType }}</span> -->
            <br />
            <div>
              <span v-if="item.channel != null"
                >销售渠道:{{ item.channel }}</span
              >
              <span v-if="item.channel == null">销售渠道:暂无</span>
            </div>
            <span>品牌负责人:{{ item.departmentLeaderName }}</span>
            <div>
              <span v-if="item.isMainPm != null"
                >项目经理:{{ item.isMainPm }}</span
              >
              <span v-if="item.isMainPm == null">项目经理:暂无</span>
            </div>
            <div>
              <span v-if="item.isMainOperation != null"
                >运营负责人:{{ item.isMainOperation }}</span
              >
              <span v-if="item.isMainOperation == null">运营负责人:暂无</span>
            </div>
            <div>
              <span v-if="item.isMainDesigr != null"
                >设计负责人:{{ item.isMainDesigr }}</span
              >
              <span v-if="item.isMainDesigr == null">设计负责人:暂无</span>
            </div>
            <span>下单时间:{{ formatDate(item.createTime) }}</span>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model:show="showPicker" round position="bottom">
      <van-picker
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { ref } from "vue";
import { Toast } from "vant";
import { useRoute } from "vue-router";
import { ProjectInformation } from "../../api";
export default {
  name: "ProjectInformation",
  setup() {
    let route = useRoute();
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const error = ref(false);
    const pageNum = ref(1);
    const token = ref(route.query.token);
    const userid = ref(route.query.userid);
    const total = ref("");
    const search = ref("");
    const screening = ref("");
    const showPicker = ref(false);
    const columns = [
      "全部",
      "未开业",
      "已开业",
      "整改中",
      "质保内",
      "质保外",
      "已完工",
    ];
    const onSearch = (val) => {
      pageNum.value = 1;
      total.value = 0;
      search.value = val;
      list.value = [];
      onLoad();
    };
    const onConfirm = (value, index) => {
      screening.value = index;
      showPicker.value = false;
      pageNum.value = 1;
      console.log(search.value + screening.value + "," + index);
      list.value = [];
      onLoad();
    };
    const onLoad = () => {
      ProjectInformation({
        token: route.query[0],
        userid: route.query[1],
        findfactor: search.value,
        screening: screening.value,
        page: pageNum.value,
        size: 20,
      })
        .then((result) => {
          if (result.data == null) {
            total.value = 0;
            Toast(result.message);
          }
          if (refreshing.value) {
            list.value = [];
            pageNum.value = 1;
            refreshing.value = false;
          }
          if (result.data != null) {
            list.value.push(...result.data.list);
            if (result.data.total == 0) {
              total.value = result.data.list.length;
            } else {
              total.value = result.data.total;
            }
            loading.value = false;
            if (result.data.hasNextPage) {
              console.log(result.data.nextPage);
              pageNum.value = result.data.nextPage;
            } else {
              finished.value = true;
            }
          } else {
            finished.value = true;
          }
        })
        .catch((err) => {
          Toast("网络错误");
          console.log(err);
          error.value = true;
          loading.value = false;
          finished.value = true;
        });
    };
    const onRefresh = () => {
      // 清空列表数据
      finished.value = false;
      pageNum.value = 1;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      onLoad();
    };
    return {
      search,
      onSearch,
      columns,
      showPicker,
      screening,
      onConfirm,
      list,
      onLoad,
      onRefresh,
      loading,
      refreshing,
      finished,
      token,
      userid,
      pageNum,
      total,
    };
  },
  methods: {
    getOpenType(type) {
      switch (type) {
        case 1:
          return "未开业";
        case 2:
          return "已开业";
        case 3:
          return "整改中";
        case 4:
          return "质保内";
        case 5:
          return "质保外";
        case 6:
          return "已完工";

        default:
          break;
      }
    },
    formatDate(date) {
      // 获取单元格数据
      let data = date;
      if (data === "") {
        return "";
      } else {
        let dt = new Date(data);
        let month =
          dt.getMonth() + 1 < 10
            ? "0" + (dt.getMonth() + 1)
            : "" + (dt.getMonth() + 1);
        let day = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
        return (
          dt.getFullYear() +
          "-" +
          // (dt.getMonth() + 1) +
          month +
          "-" +
          // dt.getDate() +
          day
        );
      }
    },
    // 返回
    onClickBack() {
      // 跳转上一级。
      if (this.z_isTap == true || this.z_isTap == "true") {
        // console.log(111);
        this.$router.go(-1);
      } else {
        console.log(222);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.webkit.messageHandlers.getDataFormVue.postMessage({
            title: "333", //vue给iOS传值
          });
        } else {
          window.android.onFinish();
        }
      }
    },
    returnType(int) {
      switch (int) {
        case 1:
          return "子单";
        case 2:
          return "母单";
        default:
          return "原单";
      }
    },
    jump(item) {
      console.log(item);
      let listData = item;
      listData.token = this.$route.query[0];
      listData.userid = this.$route.query[1];
      listData.executeStatus = this.getOpenType(item.executeStatus);
      this.$router.push({
        path: "/ProjectDetails",
        query: listData,
      });
    },
  },
};
</script>

<style scoped>
:deep(.van-nav-bar__arrow) {
  color: black !important;
}
:deep(.van-nav-bar__title) {
  color: black !important;
}
.van-search {
  background: #f3f3f3;
}
</style>
